import React from 'react';
import { useForm, ValidationError } from '@formspree/react';
import './ContactForm.css';

const ContactForm = ({ onClose }) => {
  const [state, handleSubmit] = useForm("mldbbwla");

  if (state.succeeded) {
    return (
      <div className="contact-success">
        <div className="success-icon">✓</div>
        <h2>Message Sent!</h2>
        <p>Thank you for reaching out. We'll get back to you shortly.</p>
        <button className="view-store-link" onClick={onClose} style={{ width: '100%', marginTop: '20px', border: 'none' }}>
          Back to Garage
        </button>
      </div>
    );
  }

  return (
    <div className="contact-form-container">
      <div className="contact-header">
        <h2>Contact Us</h2>
        <p>Have questions about your build? Get in touch with our experts.</p>
      </div>

      <form onSubmit={handleSubmit} noValidate>
        {/* Honeypot field - Formspree supports _gotcha out of the box */}
        <div className="hp-field" aria-hidden="true">
          <input 
            type="text" 
            name="_gotcha" 
            tabIndex="-1" 
            autoComplete="off" 
          />
        </div>

        <div className="form-group">
          <label htmlFor="full-name">Full Name</label>
          <input
            type="text"
            id="full-name"
            name="name"
            placeholder="Your Name"
            required
          />
          <ValidationError 
            prefix="Name" 
            field="name"
            errors={state.errors}
            className="error-message"
          />
        </div>

        <div className="form-group">
          <label htmlFor="email">Email Address</label>
          <input
            type="email"
            id="email"
            name="email"
            placeholder="name@example.com"
            required
          />
          <ValidationError 
            prefix="Email" 
            field="email"
            errors={state.errors}
            className="error-message"
          />
        </div>

        <div className="form-group">
          <label htmlFor="message">Message</label>
          <textarea
            id="message"
            name="message"
            rows="5"
            placeholder="Tell us about your project..."
            required
          ></textarea>
          <ValidationError 
            prefix="Message" 
            field="message"
            errors={state.errors}
            className="error-message"
          />
        </div>

        {state.errors && state.errors.length > 0 && !state.errors.some(e => e.field) && (
            <div className="form-error-banner">Something went wrong. Please try again later.</div>
        )}

        <button 
          type="submit" 
          className={`submit-btn ${state.submitting ? 'loading' : ''}`}
          disabled={state.submitting}
        >
          {state.submitting ? (
            <span className="spinner"></span>
          ) : 'Send Message'}
        </button>
      </form>
    </div>
  );
};

export default ContactForm;
